import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { usePageMeta } from "../lib/api";

const NotFound = () => {
  usePageMeta("Page Not Found | Show Me Shield", "The page you are looking for does not exist.", { noindex: true });

  return (
    <main className="bg-ink grid-lines min-h-[60vh]" data-testid="not-found-page">
      <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6 sm:py-32">
        <p className="eyebrow mb-4">404</p>
        <h1 className="h-display text-4xl text-white sm:text-5xl">This page isn&apos;t covered.</h1>
        <p className="mx-auto mt-5 max-w-md text-base leading-relaxed text-zinc-400">
          The page you&apos;re looking for doesn&apos;t exist — but your protection questions still
          have answers.
        </p>
        <div className="mt-9 flex flex-col justify-center gap-4 sm:flex-row">
          <Link to="/" data-testid="not-found-home-link" className="btn-lime">
            Back to Home <ArrowRight className="h-4 w-4" />
          </Link>
          <Link to="/contact" data-testid="not-found-contact-link" className="btn-ghost">
            Talk With a Real Person
          </Link>
        </div>
      </div>
    </main>
  );
};

export default NotFound;
